import styled from 'styled-components';

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > p {
    text-align: center;
    max-width: 410px;

    margin-bottom: 20px;

    margin-top: 80px;
  }
`;
